<template>
  <main class="container contact">
    <section class="wellcome-section">
      <p class="sub">Contact</p>
      <h2>Smile with CESCO</h2>
      <p>
        CESCO, a global environmental sanitation company committed to a clean environment for a healthier tomorrow, protects your smile.
        <br class="pc_show" />
        We precisely diagnose the issues in your area, offering the best solutions for your everyday hygiene concerns.
      </p>
      <a id="applyButton" href="mailto:'sj.kim@cesco.co.kr'"> Send Email </a>
    </section>

    <section class="section contact-1">
      <div>
        <h3>
          Trusted by 450,000 customers, we are
          <br class="pc_show" />
          dedicated professionals in global
          <br class="pc_show" />
          environmental sanitation.
        </h3>
        <p>
          Addressing pests, bacteria, and harmful germs fundamentally,
          <br class="pc_show" />
          we also ensure safe disinfection management against viruses that threaten our lives.
          <br class="pc_show" />
          As a leading global environmental sanitation company,
          <br class="pc_show" />
          we are committed to improving environmental and hygiene standards.
          <br class="pc_show" />
          Our ongoing research in environmental sanitation is our response to
          <br class="pc_show" />
          the trust our customers have placed in us.
        </p>
      </div>
    </section>

    <section class="section contact-2">
      <div class="contents-center">
        <h3 class="title-section center">Location</h3>

        <div class="map">
          <div class="map-top">
            <h4>South Korea</h4>
            <a class="btn" href="mailto:'sj.kim@cesco.co.kr'">Send Email</a>
          </div>

          <div class="map-contant">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3163.2007753207727!2d127.17166191246581!3d37.550333224938804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357cafe31284bbaf%3A0x9a46ea9114e17fd7!2sCESCO!5e0!3m2!1sen!2skr!4v1735888134624!5m2!1sen!2skr"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          <div class="map-bottom">
            <h5>Seoul</h5>
            <p>05288, CESCO Touch Center, 46 Sangil-ro 10-gil, Gangdong-gu, Seoul</p>
          </div>
        </div>

        <div class="map">
          <div class="map-top">
            <h4>China</h4>
            <a class="btn" href="mailto:'kimek4@cesco.co.kr'">Send Email</a>
          </div>

          <div class="map-contant">
            <iframe :src="chinaTabList[chinaTab].src" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>

          <div class="map-bottom">
            <div class="map-list">
              <button
                v-for="item in chinaTabList"
                :key="`map-list-${item.value}`"
                :class="{ selected: item.value === chinaTab }"
                @click="handleTabClick('china', item.value)"
              >
                <h5>{{ item.name }}</h5>
                <p>{{ item.content }}</p>
              </button>
            </div>
          </div>
        </div>

        <div class="map">
          <div class="map-top">
            <h4>Vietnam</h4>
            <a class="btn" href="mailto:'vietnam@cesco.co.kr'">Send Email</a>
          </div>

          <div class="map-contant">
            <iframe :src="vietnamTabList[vietnamTab].src" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>

          <div class="map-bottom">
            <div class="map-list">
              <button
                v-for="item in vietnamTabList"
                :key="`map-list-${item.value}`"
                :class="{ selected: item.value === vietnamTab }"
                @click="handleTabClick('vietnam', item.value)"
              >
                <h5>{{ item.name }}</h5>
                <p>{{ item.content }}</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="contact-footer">
      <h2>CESCO’s Science manages your daily life.</h2>
      <p>Explore products rigorously tested for their ability to sterilize viruses and bacteria.</p>
      <a class="btn" href="mailto:'sj.kim@cesco.co.kr'">Send Email</a>
    </section>
  </main>
</template>

<script setup>
import { ref } from 'vue'

const chinaTab = ref(0)
const chinaTabList = [
  {
    value: 0,
    name: "Xi'an",
    content: '5F E1 Zhongsheng Building, Entrepreneurial Development Park No.6, Jinye Road No.69 Yanta Xi’an China',
    src: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1650.0456420919663!2d108.86067940477699!3d34.195144!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x366376f3ee91040f%3A0x92e08ceea3b65a35!2sZhongsheng%20Mansion%20Parking%20Lot!5e0!3m2!1sko!2skr!4v1736817636600!5m2!1sko!2skr'
  },
  {
    value: 1,
    name: 'Shanghai',
    content: 'Room 603-605, 6/F, Guilin Science & Technology Park, Shanghai, 333 Guiping Road, Xuhui District, Shanghai',
    src: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d426.7711844874533!2d121.4058137!3d31.160572!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35b2648ed5909bf7%3A0xd72f06d7d6b6f8d3!2sBi%20Li%20Shi%20Wa%20Long%20Region%20Healthy%20Industrial%20Park!5e0!3m2!1sko!2skr!4v1736816456518!5m2!1sko!2skr'
  },
  {
    value: 2,
    name: 'Beijing',
    content: 'Room No. 816, Xinhuakeji B/D 8 floor, Tuofangying-lu No8, Jiangtai-Xiang, Chaoyang District, Beijing, China',
    src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.0197621025336!2d116.50136391136166!3d39.96331086713039!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35f1abdcdccf2a49%3A0x499daef1f1fddf03!2sXinhua%20Science%20and%20Technology%20Building-Parking%20Lot!5e0!3m2!1sko!2skr!4v1736817589813!5m2!1sko!2skr'
  },
  {
    value: 3,
    name: 'Guangzhou',
    content: 'Room 3010, 3/F, Yin Long Building, 433, Tianhe District, Guangzhou, Guangdong, PRC',
    src: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d917.012090084349!2d113.3355889023885!3d23.16843499999999!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3402fe7d6b3022fd%3A0xd1a0c6317b92edc9!2sXiang%20Li%20Xiang%20Qin%20Private%20Kitchens!5e0!3m2!1sko!2skr!4v1736817672715!5m2!1sko!2skr'
  }
]

const vietnamTab = ref(0)
const vietnamTabList = [
  {
    value: 0,
    name: 'Ho Chi Minh City',
    content: 'CESCO VIETNAM CO., LTD.HCMC: No.1, 18A St., An Phu Ward, Thu Duc City, Ho Chi Minh City, Vietnam',
    src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d57877.94932974507!2d106.67779419686386!3d10.785479311907649!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x317527921dc3219d%3A0xbe47df7505d02f08!2sC%C3%94NG%20TY%20TNHH%20CESCO%20VI%E1%BB%86T%20NAM!5e0!3m2!1sen!2skr!4v1736238081162!5m2!1sen!2skr'
  },
  {
    value: 1,
    name: 'Hanoi',
    content: 'CESCO VIET NAM - HANOI: Floor 2, Don Nguyen A, OCT1 Building, Co Nhue - Xuan Dinh Urban Area, Co Nhue 2 Ward, Bac Tu Liem District',
    src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1819.0745596887314!2d105.86218090065302!3d21.013890668611626!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3135ab59da3dad55%3A0xfea1c46865ef8b9a!2sC%C3%94NG%20TY%20TNHH%20CESCO%20VI%E1%BB%86T%20NAM!5e0!3m2!1sen!2skr!4v1736238225682!5m2!1sen!2skr'
  }
]

const handleTabClick = (value, index) => {
  if (value === 'china') {
    chinaTab.value = index
  } else {
    vietnamTab.value = index
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/contact.scss';
</style>
